import { render, staticRenderFns } from "./ProductcentermeidushaView.vue?vue&type=template&id=761d685a&scoped=true"
import script from "./ProductcentermeidushaView.vue?vue&type=script&lang=js"
export * from "./ProductcentermeidushaView.vue?vue&type=script&lang=js"
import style0 from "./ProductcentermeidushaView.vue?vue&type=style&index=0&id=761d685a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d685a",
  null
  
)

export default component.exports